<!-- 事務局メッセージタブ（医師心理士向け）
     Teacher/tabs/Messages.vue と同等の実装。
     共通化する場合は Teacher 側も合わせて修正すること。 -->
<template>
  <div>
    <spacer :y="5"/>
    <loader-simple :flag="flag.loader">
      <div v-if="flag.error">
        <spacer :y="4"/>
        <p>メッセージの読み込みに失敗しました。ページをリロードしてください。</p>
      </div>

      <div v-if="!flag.loader && !flag.error">
        <contents-box title="メッセージ登録">
          <div>
            <textarea
              :class="$style.textarea"
              placeholder="内容を入力してください"
              v-model="message">
            </textarea>
          </div>
          <spacer :y="3"/>
          <btn-container>
            <basic-btn
              tag="button"
              v-on:click="submit">登録する</basic-btn>
          </btn-container>
        </contents-box>

        <spacer :y="4"/>

        <contents-box v-if="data && data.messages && data.messages.length">
          <div>
            <div :class="$style.comment" v-for="chat in data.messages" :key="chat.id">
              <stack-item
                :class="chat.user.account_type === 31 ? $style.q : $style.a">
                <div :class="chat.user.account_type === 31 ? $style.question : $style.answer">
                  <div :class="$style.name">{{ chat.user.account_type === 31 ? '事務局' : chat.user.username }} [{{ filterMoment(chat.updated_at, 'YYYY.MM.DD HH:mm') }}]</div>
                  <spacer :y="1"/>
                  <div>
                    <p :class="$style.messageBody">{{ chat.message }}</p>
                  </div>
                </div>
              </stack-item>
            </div>
          </div>
        </contents-box>
      </div>
    </loader-simple>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ContentsBox from '@/views/components/ContentsBox.vue';
import StackItem from '@/views/components/StackItem.vue';
import Spacer from '@/views/components/Spacer.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import BasicBtn from '@/views/components/BasicBtn.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import cf from '@/mixins/commonFunctions';

export default {
  name: 'Messages',
  mixins: [cf],
  components: {
    ContentsBox,
    StackItem,
    Spacer,
    LoaderSimple,
    BasicBtn,
    BtnContainer,
  },
  // 他タブコンポーネント（Home等）とpropsインターフェースを揃えるために定義
  props: {
    project: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      messageGroupId: null,
      data: null,
      message: null,
      flag: {
        loader: true,
        error: false,
      },
    };
  },
  created() {
    this.initMessageGroup();
  },
  computed: {
    ...mapState(['user', 'helper']),
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    /** メッセージグループを取得または作成し、詳細を表示 */
    async initMessageGroup() {
      const operatorUserId = 1; // 事務局ユーザID（usersテーブル）
      const messageGroupTargetType = 2; // 事務局個別メッセージ（message_group_target_types）
      try {
        let response = await this.axios({
          method: 'GET',
          url: '/v1/messagegroup/get/list',
          params: {
            user_id: operatorUserId,
            target_user_id: this.user.id,
            target_type: messageGroupTargetType,
            isOperator: 1,
          },
        });
        if (response.data.groups.data.length === 0) {
          const data = {
            user_id: operatorUserId,
            target_type: messageGroupTargetType,
            target_user_id: this.user.id,
          };
          response = await this.axios({
            method: 'POST',
            url: '/v1/messageGroup/set/register',
            data,
          });
          this.messageGroupId = response.data.group_id;
        } else {
          this.messageGroupId = response.data.groups.data[0].id;
          await this.updateReadflags(response.data.groups.data[0]);
        }
        await this.getDetail();
      } catch (error) {
        if (error.response) console.log(error.response.data);
        else console.log(error);
        this.flag.error = true;
        this.flag.loader = false;
      }
    },

    /** メッセージ詳細を取得 */
    async getDetail() {
      try {
        const response = await this.axios({
          method: 'GET',
          url: '/v1/messagegroup/get/detail',
          params: {
            id: this.messageGroupId,
            isOperator: 1,
          },
        });
        this.data = response.data.detail;
        this.flag.loader = false;
      } catch (error) {
        if (error.response) console.log(error.response.data);
        else console.log(error);
        this.flag.error = true;
        this.flag.loader = false;
      }
    },

    /** メッセージ送信 */
    submit(e) {
      e.preventDefault();
      if (!this.message) {
        return alert('メッセージが入力されていません。');
      }
      const submitConfirm = confirm('返信は取り消せません。よろしいですか？');
      if (!submitConfirm) return;

      this.showLoading();

      const data = {
        group_id: this.data.id,
        messageData: {
          user_id: this.user.id,
          message: this.message,
        },
      };

      this.axios({
        method: 'POST',
        url: '/v1/messageGroup/set/register',
        data,
      })
        .then(async () => {
          alert('メッセージを登録しました');
          this.message = null;
          this.hideLoading();
          this.flag.loader = true;
          this.getDetail();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          this.hideLoading();
          alert('メッセージの送信に失敗しました。');
        });
    },

    /** 既読フラグを更新 */
    async updateReadflags(messageGroup) {
      const receiveMessages = messageGroup.messages.filter((msg) => msg.user_id !== this.user.id);
      const readMessageIds = this.user.readflags ? this.user.readflags.operatorMessages || [] : [];
      const unreadMessages = receiveMessages.filter((msg) => !readMessageIds.includes(msg.id));
      if (unreadMessages.length === 0) {
        return;
      }
      try {
        await Promise.all(unreadMessages.map((msg) => {
          const data = {
            model_type: 6, // メッセージグループ（read_flag_model_types）
            user_id: this.user.id,
            foreign_id: msg.id,
          };
          return this.axios({
            method: 'POST',
            url: '/v1/readflag/set/register',
            data,
          });
        }));
        await this.$store.dispatch('user/update');
      } catch (error) {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" module>
.textarea {
  padding: 20px;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  width: 100%;
  border-radius: 8px;
  resize: vertical;
  min-height: 120px;
}

.comment {
  margin-bottom: 24px;
  &:not(:first-child) >li {
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: -24px;
      left: 30px;
      width: 3px;
      height: 24px;
    }

    &.q {
      &::before {
        background-color: var(--blue-main);
      }
    }
    &.a {
      &::before {
        background-color: var(--orange-main);
      }
    }
  }
  .name {
    font-size: 12px;
  }
}

.messageBody {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.question, .answer {
  padding: 15px;
  border-radius: 8px;
}

.question {
  background-color: rgba(var(--blue-main-rgb), 0.2);
}
.answer {
  background-color: rgba(var(--orange-main-rgb), .2);
}
</style>
